import { add } from './add';
import { boxPlot } from './boxPlot';
import { autoCorrelation } from './autoCorrelation';
import { crossCorrelation } from './crossCorrelation';
import { correlation } from './correlation';
import { divide } from './divide';
import { findClosestIndex } from './findClosestIndex';
import { getFromToIndex } from './getFromToIndex';
import { getTargetIndex } from './getTargetIndex';
import { multiply } from './multiply';
import { rotate } from './rotate';
import { subtract } from './subtract';

export const X = {
  add,
  autoCorrelation,
  boxPlot,
  correlation,
  crossCorrelation,
  divide,
  findClosestIndex,
  getFromToIndex,
  getTargetIndex,
  multiply,
  rotate,
  subtract,
};
